import { graphql } from "@/gql";
import { ResultOf } from "@graphql-typed-document-node/core";

export const promotionCreativeQuery = graphql(`
  query RelocationPromotionCreative($relocationId: ID!) {
    relocationPromotionCreative(relocation_id: $relocationId) {
      title
      body
      target_url
      image_url
    }
  }
`);

export type PromotionCreative = ResultOf<
  typeof promotionCreativeQuery
>["relocationPromotionCreative"];
